import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Grid } from "@/comn/components";
import { comnUtils } from "@/comn/utils"; // 프로젝트 공통 유틸
import { Page, Group, Layout, Button } from "@/comn/components"; // 화면 구성 컴포넌트
import {
    useForm,
    useFetch,
    useResource,
    useGrid,
    useModal,
    useStore,
    useToast,
    usePopup,
    usePage,
    useAuth,
} from "@/comn/hooks"; // hook
import { URLS, APIS, SF_RESD_FAIL_SRCH, SG_BLL_RESD_FAIL_LIST } from "./services/OsciBllRgService"; // 서비스
import dayjs from "dayjs";

/*
 * Re-send Fail Notice List
 * !== 고지 재전송 실패 목록 ==!
 */
export const OSCI0406004Q = (props: any) => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0003"],
    });
    const { t } = useTranslation(); // Translation Hook !== 언어 변환 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const popup = usePopup(); // Popup Hook !== Popup Hook ==!
    const auth = useAuth();
    const [sendTpCd, setSendTpCd] = useState("A");

    useResource({
        defaultSchema: [{ area: "cstmCd" }, { area: "coCd" }, { area: "bnkCd" }, { area: "comnCd", comnCd: "OSC0076" }],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Re-send Fail List Form !== 재전송 실패 목록 폼 ==!
        resdFailSrch: useForm({
            defaultSchema: SF_RESD_FAIL_SRCH,
            defaultValues: {
                strtDt: comnUtils.getDate({ d: -7 }),
                endDt: comnUtils.getDate(),
                sendStts: "F",
                sendTpCd: "A",
                ...(pgeStore?.form || {}),
            },
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Bill Re-send Fail List Grid !== 고지 재전송 실패 목록 그리드 ==!
        bllResdFailList: useGrid({
            defaultSchema: SG_BLL_RESD_FAIL_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Get Bill Re-send Fail List !== 고지 재전송 실패 목록 조회 ==!
        getBillResdFailList: useFetch({
            api: (page = grid.bllResdFailList.page) => {
                return APIS.getBillResdFailList(form.resdFailSrch.getValues(), page, grid.bllResdFailList.size);
            },
            enabled: comnUtils.isEmpty(form.resdFailSrch.errors) && form.resdFailSrch.isSubmitted && sendTpCd == "A",
            key: [grid.bllResdFailList.page, grid.bllResdFailList.size],
            onSuccess: (data) => {
                setStore(pgeUid, {
                    form: form.resdFailSrch.getValues(),
                    page: grid.bllResdFailList.page,
                    size: grid.bllResdFailList.size,
                });
            },
            onError: () => {},
            showToast: true,
        }),
        // ZanMalipo Send !== ZanMalipo 전송 ==!
        zmpSend: useFetch({
            api: (data) => APIS.zmpSend({ zanMalipoSendLst: data }),
            onSuccess: (data) => {
                modal.openModal({
                    content: "msg.osc.00031", // Processed successfully.
                });
            },
            onError: () => {},
            showToast: true,
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // Get Re-send Fail List !== 재전송 실패 목록 조회 ==!
        getResdFailList: () => {
            form.resdFailSrch.handleSubmit(
                (data) => {
                    grid.bllResdFailList.setPage(0);
                    fetch.getBillResdFailList.fetch(0);
                },
                (data) => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" });
                },
            )();
        },
        // RG Send !== RG 전송 ==!
        zmpSend: () => {
            const data = grid.bllResdFailList.getChecked();

            if (data.length == 0) {
                toast.showToast({ type: "warning", content: "msg.osc.00009" });
                return false;
            } else if (data.length > 10) {
                toast.showToast({ type: "warning", content: t("msg.osc.00184", { 0: "10" }) }); // only maximum of 10 notices can be sent at once.
                return false;
            }

            modal.openModal({
                content: t("msg.osc.00047", { 0: "Bill" }), // Do you want to send Bill?
                onConfirm: () => {
                    fetch.zmpSend.fetch(data);
                },
                onCancel: () => {
                    return false;
                },
            });
        },
    };

    const render = {
        grid_resdFailList: {
            cell: {
                bllNo: (props: any) => {
                    const { rowValues } = props;
                    return (
                        <span style={{ color: "blue" }}>
                            <Link
                                to=""
                                onClick={() => {
                                    let nBllMgmtId = `${rowValues.bllTpCd}-${rowValues.bllSysmCd}-${rowValues.bllYy}-${rowValues.bllSrno}-${rowValues.bllDgr}`;
                                    popupFunc.openBllPopup(nBllMgmtId); // 고지정보 조회 팝업
                                }}
                            >{`${rowValues.bllNo}`}</Link>
                        </span>
                    );
                },
                tansadNo: (props: any) => {
                    const { rowValues } = props;
                    return (
                        rowValues.reffKeyTpCd == "T" && (
                            <span style={{ color: "blue" }}>
                                <Link
                                    to=""
                                    onClick={() => {
                                        popupFunc.openTansadPopup(`${rowValues.tansadNo}`); // TANSAD정보 조회 팝업
                                    }}
                                >{`${rowValues.tansadNo}`}</Link>
                            </span>
                        )
                    );
                },
                txprTin: (props: any) => {
                    const { rowValues } = props;
                    return `[${rowValues.txprTin}] ${rowValues.txprNm}`;
                },
            },
            checkbox: (row: any) => {
                if (row.ntcTpCd == "C" || row.totAmt > 0) {
                    return true;
                } else {
                    return false;
                }
            },
        },
    };

    // 팝업 호출
    const popupFunc = {
        // 고지 팝업
        openBllPopup: (bllNo: any) => {
            popup.openPopup({
                url: `${URLS.osci0401002q}/${bllNo}`,
                size: "md",
                layout: "popup",
                callback: (data: any) => {
                    console.log(data);
                },
            });
        },
        // TANSAD 팝업
        openTansadPopup: (tansadNo: any) => {
            popup.openPopup({
                url: `${URLS.osci0202002q}/${tansadNo}`,
                size: "md",
                layout: "popup",
                callback: (data: any) => {
                    console.log(data);
                },
            });
        },
    };

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        handler.getResdFailList();
    }, []);

    return (
        <Page>
            <form>
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.resdFailSrch.schema.cstmOfceCd}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.resdFailSrch.schema.sendDt}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control
                                    {...form.resdFailSrch.schema.sendTpCd}
                                    onChange={(v) => {
                                        setSendTpCd(v);
                                    }}
                                ></Group.Control>
                                <Group.Control {...form.resdFailSrch.schema.sendStts}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.resdFailSrch.schema.ntcTpCd}></Group.Control>
                            </Group.Row>
                        </Group.Section>
                        <Layout direction="row">
                            <Layout.Left>
                                <Button
                                    role="reset"
                                    onClick={() => {
                                        form.resdFailSrch.reset();
                                    }}
                                ></Button>
                            </Layout.Left>
                            <Layout.Right>
                                <Button
                                    role="search"
                                    onClick={() => {
                                        handler.getResdFailList();
                                    }}
                                ></Button>
                            </Layout.Right>
                        </Layout>
                    </Group.Body>
                </Group>
            </form>

            <Group>
                <Group.Body>
                    <Button
                        role="excelDown"
                        onClick={() => {
                            const tgGrid = grid.bllResdFailList;

                            tgGrid.exportExcel({
                                /* 다운로드 엑셀 파일명 (확장자 없이), 기본값 Export(년월일시분초) */
                                excelName: dayjs().format("YYYY-MM-DD HH:mm:ss") + "_" + pgeUid,

                                /* 다운로드 엑셀 시트명 , 기본값 Sheet */
                                sheetName: "Sheet Name",
                            });
                        }}
                    ></Button>
                    <Group.Section>
                        {/* <span>only maximum of 10 notices can be sent at once.</span> */}
                        <Grid
                            {...grid.bllResdFailList.grid}
                            data={fetch.getBillResdFailList.data?.resdFailList}
                            render={render.grid_resdFailList}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>
            {/* <Layout direction="row">
                <Layout.Right>
                    <Button
                        onClick={() => {
                            handler.zmpSend();
                        }}
                    >
                        {t("B_ZMP_SEND")}
                    </Button>
                </Layout.Right>
            </Layout> */}
        </Page>
    );
};
